import React, { ChangeEvent } from "react";
import { toast } from "react-toastify";
import { Button, Col, Form, FormGroup, Input, Label, Row } from "reactstrap";
import { AadhaarNumber, ChooseBanks, Continue, PAN, Previous } from "../../../../../../../constants";
import { ActiveCallbackProp, BankFormData } from "../../../../../../../types/Forms";
import { dynamicImage } from "../../../../../../../utils";
import { PopularBanksList } from "../../../../../../../data/formsAndTable/forms/FormLayout";
import { useForm } from "react-hook-form";
import { Image } from "../../../../../../../coreComponents/Image";

const BankInfoForm: React.FC<ActiveCallbackProp> = ({ activeCallBack }) => {
  const {
    register,
    formState: { errors },
    setValue,
    watch,
    handleSubmit,
  } = useForm<BankFormData>({});

  const formData = watch();

  const updateFormData = (event: ChangeEvent<HTMLInputElement>) => {
    setValue(event.target.name as keyof BankFormData, event.target.value, {
      shouldValidate: true,
      shouldDirty: true,
    });
  };

  const handleNextButton = handleSubmit(
    () => {
      if (formData.aadhaarNumber !== "" && formData.panNumber !== "" && formData.bankName !== "") activeCallBack(3);
    },
    () => {
      toast.error("Please fill out all the fields before moving on to the next step");
    }
  );

  return (
    <Form onSubmit={(event) => event.preventDefault()} className="needs-validation" noValidate>
      <Row className="g-3">
        <Col sm="6" className="bank-search">
          <Label>
            {AadhaarNumber}
            <span className="txt-danger">*</span>
          </Label>
          <Input {...register("aadhaarNumber", { required: "Aadhaar number is required" })} value={formData.aadhaarNumber} onChange={updateFormData} type="number" placeholder="xxxx xxxx xxxx xxxx" />
          {errors.aadhaarNumber && <span className="text-danger">{errors.aadhaarNumber.message}</span>}
        </Col>
        <Col sm="6" className="bank-search">
          <Label>
            {PAN}
            <span className="txt-danger">*</span>
          </Label>
          <Input {...register("panNumber", { required: "PAN number is required" })} type="text" placeholder="xxxxxxxxxx" value={formData.panNumber} onChange={updateFormData} />
          {errors.panNumber && <span className="text-danger">{errors.panNumber.message}</span>}
        </Col>
        <Col xs="12">
          <h6>{ChooseBanks}</h6>
          <div className="bank-selection">
            <FormGroup check className="radio radio-primary ps-0">
              <ul className="radio-wrapper">
                {PopularBanksList.map((data, index) => (
                  <li key={index}>
                    <Input {...register("bankName", { required: "Bank name is required" })} id={data.bankName} type="radio" value={data.bankName} checked={formData.bankName === data.bankName} onChange={updateFormData} />
                    <Label htmlFor={data.bankName} check>
                      <Image src={dynamicImage(`forms/${data.image}`)} alt="bank" />
                      <span>{data.bankName}</span>
                    </Label>
                  </li>
                ))}
              </ul>
              {errors.bankName && <span className="text-danger">{errors.bankName.message}</span>}
            </FormGroup>
          </div>
        </Col>
        <Col xs="12" className="text-end">
          <Button color="primary" className="me-2" onClick={() => activeCallBack(1)}>
            {Previous}
          </Button>
          <Button color="primary" onClick={handleNextButton}>
            {Continue}
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

export default BankInfoForm;
